// extracted by mini-css-extract-plugin
module.exports = {"status":"maintenanceList_status__1b5yq","InProgress":"maintenanceList_InProgress__1_peS","closed":"maintenanceList_closed__1xpkO","new":"maintenanceList_new__1ymBB"};